import React from 'react'
import { useSelector } from 'react-redux'
import { selectSelectedGeoentityIdentityCard } from '../../store/geoentity/geoentity.selectors'
import SVGIcon from '../svg/SVGIcon'
import SeoBackgroundImage from './SeoBackgroundImage'
import s from './ThreeImageGrid.less'

export default function ThreeImageGrid({ images = [], onClick }) {
  const [firstImg, secondImg, thirdImg] = images.slice(0, 3)
  const { name } = useSelector(selectSelectedGeoentityIdentityCard)
  const total = images.length

  if (!firstImg) return null

  return (
    <div className={s.ThreeImageGrid} onClick={onClick}>
      <div className={s.bigThumbnailCtn}>
        <SeoBackgroundImage alt={name} imgUrl={firstImg} className={s.images} />
      </div>
      <div className={s.littleThumbnailsCtn}>
        {secondImg && <SeoBackgroundImage alt={name} imgUrl={secondImg} className={s.images} />}
        {thirdImg && <SeoBackgroundImage alt={name} imgUrl={thirdImg} className={s.images} />}
        {thirdImg && total > 1 && (
          <div className={s.cameraCtn}>
            <SVGIcon className={s.cameraIcon} icon="photo-video" />
            <span className={s.totalNumber}>{total}</span>
          </div>
        )}
      </div>
    </div>
  )
}
